import { QuestionType } from '@features/event-registration/types';
import { FormFieldData } from '@features/forms/types';
import {
  bloodGroupOptions,
  isInuredOptions
} from '@features/member-management/constants';
import { CustomFieldConfig } from '@features/member-management/types';

import { MEMBER_FIELD_CATALOG } from '../constants';

export type MemberCustomFieldCatalogEntry = {
  key: string;
  label: string;
  type: QuestionType;
  required: boolean;
  order: number;
  options?: string[];
};

const getLastStaticCatalogOrder = () =>
  Math.max(...MEMBER_FIELD_CATALOG.map((entry) => entry.order), 0);

export const mapMemberCustomFieldType = (
  configType: string,
  key: string
): Pick<MemberCustomFieldCatalogEntry, 'type' | 'options'> => {
  if (key === 'blood_group' && configType === 'varchar') {
    return {
      type: QuestionType.DROP_DOWN,
      options: bloodGroupOptions.map((option) => option.label)
    };
  }

  switch (configType) {
    case 'number':
      return { type: QuestionType.NUMBER };
    case 'textarea':
      return { type: QuestionType.TEXT_AREA };
    case 'date':
      return { type: QuestionType.DATE };
    case 'bool':
      return {
        type: QuestionType.SINGLE_CHOICE,
        options: isInuredOptions.map((option) => option.value)
      };
    case 'varchar':
    default:
      return { type: QuestionType.TEXT };
  }
};

export const buildMemberCustomFieldCatalogEntries = (
  customFields: CustomFieldConfig[]
): MemberCustomFieldCatalogEntry[] => {
  const baseOrder = getLastStaticCatalogOrder();

  return customFields.map((field, index) => {
    const mapped = mapMemberCustomFieldType(field.type, field.key);
    return {
      key: field.key,
      label: field.label,
      type: mapped.type,
      required: false,
      order: baseOrder + index + 1,
      ...(mapped.options ? { options: mapped.options } : {})
    };
  });
};

export const mapCustomCatalogEntryToFormField = (
  entry: MemberCustomFieldCatalogEntry,
  required = entry.required
): FormFieldData => ({
  id: `member-custom-${entry.key}`,
  label: entry.label,
  type: entry.type,
  required,
  order: entry.order,
  fieldCategory: 'member',
  memberCustomFieldKey: entry.key,
  syncToMember: true,
  ...(entry.options ? { options: entry.options } : {})
});
